var WDN = WDN || {};

if (typeof WDN.Footer === "undefined") {
  WDN.Footer = (function () {
    var init;
    var renderNewsletter, renderChunk;

    renderNewsletter = function () {
      if (!document.querySelector("[data-footer-newsletter]")) return;
      new WDN.SectionRenderer({
        selectors: {
          output: "[data-footer-newsletter]",
        },
        autoInit: true,
        replaceOutput: true,
        sections: ["async-footer-newsletter"],
      });
    };

    renderChunk = function () {
      if (!document.querySelector("[data-footer-chunk]")) return;
      new WDN.SectionRenderer({
        selectors: {
          output: "[data-footer-chunk]",
        },
        autoInit: true,
        replaceOutput: true,
        sections: ["async-footer-chunk"],
        callback: function () {
          WDN.CountrySelect.Renderer.reinit();
        },
      });
    };

    init = function () {
      // Newsletter async load
      renderNewsletter();

      // Chunk async load (country select and payment methods)
      renderChunk();
    };

    // Init (timeout so it is not prioritized early on load)
    setTimeout(function () {
      init();
    }, 500);

    return {};
  })();
}
